import { Fragment } from "react";

import useAccountCreationEmailVerificationSent from "./UseAccountCreationEmailVerificationSent";

import Headings from "@usas/ui-web/components/headings/Headings";

import style from '../../../../LandingPages.module.css';
import AccountCreationReturnButton from "../../components/buttons/AccountCreationReturnButton";

const AccountCreationEmailVerificationSent = () => {
  const {
    emailAddress,
  } = useAccountCreationEmailVerificationSent();

  return (
    <Fragment>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-md-2" />
        <div className={['col-xs-12', 'col-md-8'].join(' ')}>
          <span className={style.CenterPageContent}>
            <Headings.H3>Check Your Email</Headings.H3>
          </span>
          <div style={{ padding: '1.5em', borderRadius: '4px' }} className={["usas-extra-top-margin usas-extra-bottom-margin", 'very-light-gray'].join(' ')}>

            <p>
              <strong>We&#39;ve sent a verification email to:</strong>
            </p>
            <p style={{ fontSize: '1.1em', fontWeight: 'bold', color: '#0066cc' }}>
              {emailAddress}
            </p>

            <div className="usas-extra-top-margin">
              <p>
                Please check your email and click the verification link to complete your account creation.
              </p>

              <ul className="row usas-extra-top-margin usas-extra-bottom-margin" style={{ listStylePosition: 'outside', paddingLeft: '2.8em', paddingRight: '2.2em' }}>
                <li>Check your spam/junk folder if you don&#39;t see the email in your inbox</li>
                <li>The verification link will expire in 24 hours</li>
                <li>Once verified, you&#39;ll be able to complete your account setup and access acknowledgements</li>
              </ul>

              <p style={{ fontSize: '0.9em', fontStyle: 'italic' }}>
                If you don&#39;t receive the email within a few minutes, please return to the login page and try again.
              </p>
            </div>
          </div>
          <span className={style.CenterPageContent}>
            <div className="row">
              <div className="col-xs-12 usas-extra-top-margin">
                <AccountCreationReturnButton />
              </div>
            </div>
          </span>
        </div>
        <div className="col-xs-12 col-md-2" />
      </div>
    </Fragment>
  );
};

export default AccountCreationEmailVerificationSent;